import React, {useEffect, useRef} from 'react';
import logo from './logo.png';
import HomeContext from "../../HomeContext";
import clsx from "clsx";
import {HeaderActions} from "presentation/common/components/layout/header-actions/HeaderActions";
import {HeaderDrawerProvider, MobileDrawer} from "presentation/common/components/layout/mobile-drawer";

import styles from './Header.module.scss';

export const Header = (props) => {
    const {bodyScrollTop} = React.useContext(HomeContext);
    const logoRef = useRef();

    useEffect(
        (e) => {
            requestAnimationFrame(() => {
                logoRef.current.style.height = (85 - (bodyScrollTop < 36 ? bodyScrollTop : 35)) + 'px';
            });
        },
        [bodyScrollTop],
    );

    return (
      <HeaderDrawerProvider>
        <div className={clsx(styles.container, {[styles.borderContainer]: bodyScrollTop > 100})}>
            <div className={styles.logo}>
                <a href="/"> <img alt="logo" src={logo} ref={logoRef}/> </a>
                <MobileDrawer  {...props} useInsideScroll/>
            </div>

            <h3 className="text-primary uppercase">Id Auto Inscripciones</h3>

            <HeaderActions {...props} useInsideScroll/>
        </div>
      </HeaderDrawerProvider>
    );
};

Header.propTypes = {}

Header.defaultProps = {}

export default React.memo(Header);
